function isValidEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

function isValidDate(s) {
	if(!parseDate(s)){
		return false
	}

	var bits = s.split("-");

	var y = bits[2], m  = bits[1], d = bits[0];
	// Assume not leap year by default (note zero index for Jan)
	var daysInMonth = [31,28,31,30,31,30,31,31,30,31,30,31];

	// If evenly divisible by 4 and not evenly divisible by 100,
	// or is evenly divisible by 400, then a leap year
	if ( (!(y % 4) && y % 100) || !(y % 400)) {
		daysInMonth[1] = 29;
	}
	return d <= daysInMonth[--m]
}

function parseDate(str) {
	var m = str.match(/^(\d{1,2})\-(\d{1,2})\-(\d{4})$/);
	return (m) ? new Date(m[3], m[2]-1, m[1]) : null;
}

/*!
 * numeral.js language configuration
 * language : netherlands-dutch (nl-nl)
 * author : Dave Clayton : https://github.com/davedx
 */
(function () {
  var language = {
    delimiters: {
      thousands: '.',
      decimal  : ','
    },
    abbreviations: {
      thousand : 'k',
      million  : 'mln',
      billion  : 'mrd',
      trillion : 'bln'
    },
    ordinal : function (number) {
      var remainder = number % 100;
      return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
    },
    currency: {
      symbol: '€ '
    }
  };

  // Node
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = language;
  }
  // Browser
  if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
    this.numeral.language('nl-nl', language);
  }
}());
